import styled from 'styled-components';

export const UploadItem = styled.div`
  width: 100%;
  display: flex;
  padding: 4px 8px;
  border-radius: 4px;
  align-items: center;
  margin-bottom: 8px;
  background-color: ${({ theme }) => theme.colors.black9} 50%;

  & > i {
    margin-right: 4px;
  }

  & > :last-child {
    margin-left: auto;
  }
`;
